module.exports = __webpack_public_path__ + "static/img/xh-right01.005627e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xh-right01.jpg
// module id = 6Ef4
// module chunks = 1